module.exports = __webpack_public_path__ + "media/images/download-a61b392f203cdc427147c26887b318ec.svg";